/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { updateWatermarkOnEstatePhotos } from '../../lib/rest/estateAPIClient'
import { useMutation } from '@tanstack/react-query'

function useUpdateEstatePhotosWatermarkMutation () {
  return useMutation({
    mutationKey: ['updateEstatePhotosWatermark'],
    mutationFn: () => updateWatermarkOnEstatePhotos()
  })
}

export default useUpdateEstatePhotosWatermarkMutation
